/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Automatic Backup Settings" |
*
* @param {Options_Backup_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_form_label = /** @type {((inputs?: Options_Backup_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de sauvegarde automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für automatische Datensicherung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di backup automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки автоматического резервного копирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de copia de seguridad automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动备份设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動バックアップ設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित बैकअप सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de backup automático")
	return /** @type {LocalizedString} */ ("Automatic Backup Settings")
});